export default __webpack_public_path__ + "static/media/regua.093953ee.png";